import { Component, OnInit } from '@angular/core';
import {GeneralTeacherComponent} from '../../General/gt.component';
import {TopicService} from '../topic.service';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-t-bubble-sort',
  templateUrl: './t-bubble-sort.component.html',
  styleUrls: ['./t-bubble-sort.component.css']
})
export class TBubbleSortComponent extends GeneralTeacherComponent {

  language: string;
  cardCount: number;
  cardIds: number[] = [];
  covered: boolean;

  constructor(protected topicsService: TopicService, protected  activatedRoute: ActivatedRoute,
              protected http: HttpClient) {
    super(topicsService, activatedRoute);
    this.type = 'bubbleSort';
    // this.loadText();
    this.title = this.get('bubbleSort');
    this.language = this.topicService.getLanguage();
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.cardIds = Object.assign([], this.configuration.typespecifics.ids);
    this.covered = this.configuration.typespecifics.covered;
    this.cardCount = this.cardIds.length;
  }

  generateDefinition() {
    const definition: any = {};
    if (this.id === undefined || this.id == null) {
      definition.id = this.topicService.getMaxId() + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    if (this.covered) {
      definition.title = this.get('bubbleSortCovered');
      definition.type = this.type;
      definition.description = this.description;
      definition.image = './assets/images/question_marks_white.png';
    } else {
      definition.title = this.title;
      definition.type = this.type;
      definition.description = this.description;
      definition.image = './assets/images/sort_white.png';
    }
    definition.level = 1;
    if (this.covered) {
      definition.key = 'sort%'.concat(this.type, '%verdeckt%%', this.id.toString());
    } else {
      definition.key = 'sort%'.concat(this.type, '%%', this.id.toString());
    }
    definition.typespecifics = {};
    definition.typespecifics.ids = Object.assign([], this.cardIds);
    if (this.covered === undefined) {
      definition.typespecifics.covered = false;
    } else {
      definition.typespecifics.covered = true;
    }
    definition.key = definition.key.concat('%teacher%', String(this.id));
    return definition;
  }

  reset() {
    super.reset();
    this.title = this.get('bubbleSort');
    this.cardIds = [];
    this.covered = undefined;
    this.cardCount = 0;
  }

  adaptCardList(cardCount: number) {
    if (this.cardIds.length < cardCount) {
      const difference = cardCount - this.cardIds.length;
      let lastId = 0;
      for (let i = 0; i < difference; i++) {
        while (this.cardIds.some(x => x === lastId)) {
          lastId ++;
        }
        this.cardIds.push(lastId);
      }
    } else {
      const oldValues = this.cardIds;
      this.cardIds = [];
      for (let i = 0; i < cardCount; i++) {
        this.cardIds.push(oldValues[i]);
      }
    }
    console.log(this.cardIds);
  }

  validValue(index: number) {
    const length = this.cardIds.length;
    const actualValue = this.cardIds[index];
    for (let i = 0; i < length; i++) {
      if (i !== index) {
        if (actualValue === this.cardIds[i]) {
          return true;
        }
      }
    }
    return false;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
